export default "__VITE_ASSET__c16061bd__"